import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { ProductModalContent } from ".";

import { Modal } from "vqp-common";
import { Loading } from "../../common";
import { fetchProduct, updateProduct } from "../../../redux/actions/products";
import { showNotification } from "../../../redux/actions/ui";

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductModal = ({
  isOpen,
  category,
  productId,
  onClose,
  onUpdate,
  storeId,
}) => {
  const [product, setProduct] = useState();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();

  const handleSubmitForm = async (formData) => {
    if (orderDetails && orderDetails.length > 0) {
      formData["details"] = orderDetails;
    }
    formData.mix = product?.mix ?? false;
    setLoading(true);
    const result = await dispatch(updateProduct({ formData, storeId }));
    setLoading(false);
    if (result.success) {
      onUpdate();
      const result = await dispatch(fetchProduct(productId, storeId));
      if (result.success) {
        setProduct(result.data);
      }
      onClose(true);
    } else {
      dispatch(
        showNotification({
          type: "error",
          text: result.error.message,
        })
      );
    }
  };

  useEffect(() => {
    const getProduct = async () => {
      setLoading(true);
      const result = await dispatch(fetchProduct(productId, storeId));
      if (result.success) {
        setProduct(result.data);
      }
      setLoading(false);
    };
    if (productId) {
      setLoading(true);
      getProduct();
    } else {
      setProduct(undefined);
    }
  }, [dispatch, productId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {loading && (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      )}
      <ProductModalContent
        loading={loading}
        product={product}
        category={category}
        onSubmitForm={handleSubmitForm}
        orderDetails={orderDetails}
        setOrderDetails={setOrderDetails}
        storeId={storeId}
      />
    </Modal>
  );
};
